function escapeHtml(value) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function splitSpecItems(text, prefixes) {
  let value = text.replace(/\s+/g, ' ').trim();
  prefixes.forEach((prefix) => {
    const pattern = new RegExp('^' + prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*:\\s*', 'i');
    value = value.replace(pattern, '');
  });

  let parts = value
    .split(/\n+|•|\u2022|\u00b7/)
    .map((part) => part.replace(/^[-*]\s+/, '').trim())
    .filter(Boolean);

  if (parts.length > 1) return parts;

  parts = value
    .split(/(?<=[.!?])\s+(?=[A-Z])/)
    .map((part) => part.trim())
    .filter(Boolean);

  if (parts.length > 1) return parts;

  const clauseStarters = [
    'Does NOT',
    'Does not',
    'Do not',
    'Will not',
    'Must use',
    'Must be',
    'Direct bolt-on',
    'Not compatible',
    'Incompatible with',
    'Requires',
    'Only fits',
    'Will not fit'
  ]
    .map((starter) => starter.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('|');

  return value
    .split(new RegExp('\\s+(?=(?:' + clauseStarters + '))'))
    .map((part) => part.trim())
    .filter(Boolean);
}

function enhanceSpecLists() {
  document.querySelectorAll('[data-auto-list]').forEach((el) => {
    if (el.dataset.listReady === 'true') return;
    if (el.querySelector('ul, ol, li')) {
      el.dataset.listReady = 'true';
      return;
    }

    const prefixes = (el.dataset.stripPrefix || '')
      .split(',')
      .map((part) => part.trim())
      .filter(Boolean);
    const parts = splitSpecItems(el.textContent || '', prefixes);

    if (parts.length > 1) {
      el.innerHTML = '<ul>' + parts.map((part) => '<li>' + escapeHtml(part) + '</li>').join('') + '</ul>';
    }

    el.dataset.listReady = 'true';
  });
}

document.addEventListener('DOMContentLoaded', enhanceSpecLists);
document.addEventListener('shopify:section:load', enhanceSpecLists);
document.addEventListener('shopify:section:reorder', enhanceSpecLists);
